/** @module csi/notification/ToolbarAssignedTasks */
define([
	"dojo/_base/declare",
	"csi/html",
	"csi/state",
	"csi/view/ToolbarPluginAnchor",
], function(declare, html, state, ToolbarPluginAnchor) {

	return declare(ToolbarPluginAnchor, {
		/** @property {DOMNode} badgeNode */
		badgeNode: null,

		/** @property {number} taskCount */
		taskCount: 0,

		/**
		 * @override
		 * Render element for task count
		 */
		buildRendering: function() {
			this.inherited(arguments);

			this.badgeNode = html.create("span", {
				"class": "csi-assigned-task-count"
			}, this.anchorNode);
		},

		/**
		 * @override
		 * Update task count when it changes
		 */
		postCreate: function() {
			this.inherited(arguments);
			this.set("taskCount", state.get("userAssignedTaskCount"));

			state.watch("camundaAssignedTaskCount", (name, oldValue, newValue) => {
				this.set("taskCount", newValue + state.get("proofingAssignedTaskCount"));
			});
			state.watch("proofingAssignedTaskCount", (name, oldValue, newValue) => {
				this.set("taskCount", newValue + state.get("camundaAssignedTaskCount"));
			});
		},

		/**
		 * Map taskCount property to DOM
		 * @param {number} value
		 */
		_setTaskCountAttr: function(value) {
			const {badgeNode} = this;
			let counterText;

			if (value >= 100) {
				counterText = "99+";
			} else if (value > 0) {
				counterText = String(value);
			} else {
				counterText = "";
			}

			html.clear(badgeNode);
			html.text(badgeNode, counterText);
			html.setVisible(badgeNode, !!counterText);

			this._set("taskCount", value);
		},
	});
});
